// "402 Lincoln Road_Flat 1_Gas Safety Certificate.pdf" (flat part left out for a whole property)
export const certificateFileName = (cert: {
  normalized_address?: string;
  property_address?: string;
  flat_number?: string[] | string | null;
  certificate_type?: string;
}): string => {
  let flats: unknown = cert.flat_number;
  if (typeof flats === 'string') {
    try { flats = JSON.parse(flats); } catch { flats = [flats]; }
  }
  const flat = Array.isArray(flats) ? flats.filter(Boolean).join(', ') : '';
  const parts = [cert.normalized_address || cert.property_address, flat, cert.certificate_type]
    .map(p => (p || '').replace(/[\\/:*?"<>|]/g, ' ').replace(/\s+/g, ' ').trim())
    .filter(Boolean);
  return `${parts.join('_') || 'certificate'}.pdf`;
};
